import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { Container } from '@/components/atoms/Layout/Layout';
import { H1, P } from '@/components/atoms/Typography/Typography';
import { HelpSection } from '@/components/local/HelpSection/HelpSection';
import nameSpacesConfig from '@/config/config.nameSpaces.json';
import styles from './CookiesPage.module.scss';

export const CookiesPage = () => {
  const { t } = useTranslation(nameSpacesConfig.pages);
  return (
    <>
      <Container className={styles.container}>
        <H1 className={styles.pageHeader}> {t(`cookies.pageTitle`)}</H1>
        <P className={styles.text}>{t(`cookies.cookiesIntro`)}</P>
        <Link href="/cookie-policy" prefetch={false} legacyBehavior>
          {t(`cookies.downloadCookiePolicy`)}
        </Link>
        <P className={styles.text}>{t(`cookies.cookiesDescription`)}</P>
        <details>
          <summary className={styles.myCookies}>
            {t(`cookies.myCookies`)}
          </summary>
          <script
            id="CookieDeclaration"
            src="https://consent.cookiebot.com/04e908d3-d9b0-4603-af20-d2d2fc2d7fb5/cd.js"
            type="text/javascript"
            async
          />
        </details>
      </Container>
      <HelpSection />
    </>
  );
};
